<script lang="ts">
    import { onMount, onDestroy } from 'svelte'
    import ChatService from '../../helpers/ChatConfigService'
    import { chatStore } from '../../stores/chatStore'

    import type { IChatSetting } from '../../lib/types'
    import ChatDisplay from '../../components/ChatDisplay.svelte'
    import ChatConfigList from '../../components/ChatConfigList.svelte'
    import FontHelper from '../../helpers/FontHelper.js'

    let previewList = []
    const defaultSettings: IChatSetting = {
        color: '#000',
        family: 'Roboto',
        files: {},
        styles: [],
        fontSize: 18,
        messagesPerMinute: 0,
        upperCase: false,
        fontWeight: 400,
        fontStyle: 'regular',
        underline: false,
    }

    const unsubscribe = chatStore.subscribe((chatConfigs) => {
        if (!chatConfigs.length) return false
        FontHelper.loadFonts(chatConfigs)
    })

    onMount(async () => {
        await ChatService.get()
    })

    onDestroy(() => {
        unsubscribe
    })

    async function createChatSettings() {
        await ChatService.create({ ...defaultSettings }).then((res) => {})
    }

    async function saveOrCreateChatSettings(config: IChatSetting) {
        const { _id, ...rest } = config
        await ChatService.update(_id, rest).then((res) => {
            if (!isConfigPreviewed(res)) return false
            previewList = filterPreviewList(res)
            previewList = [...previewList, res]
        })
    }

    async function removeChatSetting(config) {
        await ChatService.remove(config._id).then((res) => {})
    }

    function addToPreviewList(config) {
        previewList = filterPreviewList(config)
        previewList = [...previewList, config]
        previewList.sort(
            (a: IChatSetting, b: IChatSetting) =>
                a.messagesPerMinute - b.messagesPerMinute
        )
    }

    function removeFromPreviewList(config) {
        const index = previewList.findIndex((el) => el == config)

        if (index != -1) {
            previewList.splice(index, 1)
            previewList = [...previewList]
        }
    }

    function isConfigPreviewed(config) {
        return previewList.find((item) => {
            return config._id === item._id
        })
    }

    function filterPreviewList(config) {
        return previewList.slice().filter((item) => {
            return item._id !== config._id
        })
    }
</script>

<div class="flex flex-row items-center place-content-between">
    <div class="flex flex-col flex-1">
        <div class="pb-2 border-b border-gray-200">
            <h3 class="text-lg leading-6 font-medium text-gray-900">
                Your Configs
            </h3>
        </div>

        <div class="mt-2">
            <h2 class="text-sm leading-4 font-light text-cool-gray-900 mb-4">
                These are the configs that you have set up, use the create
                button to add a new one
            </h2>
        </div>
    </div>
    <div class="ml-5">
        <button
            type="button"
            on:click={createChatSettings}
            class="inline-flex h-9 justify-center py-2 px-4 border border-transparent text-sm leading-5 font-medium rounded-md text-white bg-orange-600 hover:bg-orange-500 focus:outline-none focus:border-orange-700 focus:shadow-outline-orange active:bg-orange-700 transition duration-150 ease-in-out">
            New
        </button>
    </div>
</div>

<ChatConfigList
    configs={$chatStore}
    save={saveOrCreateChatSettings}
    {addToPreviewList}
    {removeFromPreviewList}
    {previewList}
    {removeChatSetting} />

<div class="mt-8 pb-2 border-b border-gray-200">
    <h3 class="text-lg leading-6 font-medium text-gray-900">Preview</h3>
</div>

<div class="mt-2">
    <h2 class="text-sm leading-4 font-light text-cool-gray-900 mb-4">
        Use the preview button to add thresholds here to see how they look
    </h2>
</div>
<ChatDisplay configs={previewList} />
